import { Component, Input, inject } from '@angular/core';
import { befreeUrlValues } from 'src/app/shared/constants';
import { DepartmentsType, TextSizes, TextType } from 'src/app/shared/enums';
import { IUser } from 'src/app/shared/services/user/user.type';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { IonicModule } from '@ionic/angular';
import { RouterLink } from '@angular/router';
import { ImageComponent } from '../image/image.component';
import { TextComponent } from '../text/text.component';

import { SvgComponent } from '../svg/svg.component';
import { ContactsComponent } from '../contacts/contacts.component';
import { AddBaseUrlPipe } from '../../pipe/add-baseUrl/add-base-url.pipe';
import { GetFullNamePipe } from '../../pipe/get-full-name/get-full-name.pipe';
import { YearsOfServiceBadgeIconPipe } from '../../pipe/years-of-service-badge-icon/years-of-service-badge-icon.pipe';
@Component({
  selector: 'app-employee-card',
  templateUrl: './employee-card.component.html',
  styleUrls: ['./employee-card.component.scss'],
  imports: [
    IonicModule,
    RouterLink,
    ImageComponent,
    TextComponent,
    SvgComponent,
    ContactsComponent,
    AddBaseUrlPipe,
    GetFullNamePipe,
    YearsOfServiceBadgeIconPipe,
  ],
})
export class EmployeeCardComponent {
  utils = inject(UtilsService);

  @Input() employee: IUser | null = null;

  @Input() isShowDepartment = false;

  @Input() isTrainingEmployees = false;

  public readonly TextSizes = TextSizes;

  public readonly TextType = TextType;

  public readonly departmentsType = DepartmentsType;

  get employeeUrl() {
    return ['/', befreeUrlValues.dashboard, befreeUrlValues.employees, this.employee!.id];
  }

  public onEmailClick(event: MouseEvent) {
    event.stopPropagation();
  }
}
